<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi1"><a id="page_1">For Bette,</a></p><a id="page_1">
</a><p class="dedi"><a id="page_1">Courageous and Loving Wife</a><a id="page_2"></a></p><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?0c5c254a